import React from "react";
import { Rect } from "react-konva";

const Rectangle = ({ shape, shapeProps }) => {
	return (
		<Rect
			{...shapeProps}
			key={shape.id}
			x={shape.x}
			y={shape.y}
			width={shape.width}
			height={shape.height}
			fill="rgba(45, 133, 71, 0.76)"
			stroke="rgba(0, 185, 56, 0.925)"
			strokeWidth={1}
		/>
	);
};

export default Rectangle;
